<template>
    <el-dialog title="视频配置" :visible="true" @close="handleCloseDialog" :close-on-click-modal="false" append-to-body>

        <el-form label-position="left" label-width="80px">
            <el-form-item label="视频源">
                <div style="display:flex;flex-wrap:wrap;">
            <div v-for="(item, index) in tempVideoSrc"  :key="index">
                <video style="width: 100px; height: 100px;margin: 10px;" :src="item" fit="fit"></video>

                <div style="display: flex;justify-content: space-around;">
                    <el-link icon="el-icon-back" @click="itemOpr('up', index)"></el-link>
                    <el-link icon="el-icon-delete" @click="itemOpr('delete', index)"></el-link>
                    <el-link icon="el-icon-right" @click="itemOpr('down', index)"></el-link>
                </div>

            </div>

            <div style=" border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;margin: 10px;   width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;font-size: 28px;
            color: #8c939d;" @click="showFileSelector = true">
            <i class="el-icon-plus avatar-uploader-icon"></i></div>
                </div>
            </el-form-item>

            <!-- <el-form-item label="视频源">
                <div style="height:200px;width:100%;margin-bottom:10px;" v-if="tempVideoSrc">
                    <video style="height:200px;max-width: 100%;" :src="tempVideoSrc" />
                </div>

                <el-button type="primary" @click="showFileSelector = true">{{ tempVideoSrc ? '重新选择' : '选择视频' }}</el-button>
            </el-form-item> -->

            <el-form-item label="播放次数">
                <el-input v-model="tempPlayTimes" style="width:350px;">
                    <template slot="prepend">循环播放</template>
                    <template slot="append">次后触发页面切换</template>
                </el-input>
            </el-form-item>

            <el-form-item label="静音播放">
                 <el-radio-group v-model="tempMuted">
                    <el-radio :label="true">静音</el-radio>
                    <el-radio :label="false">不静音</el-radio>
                </el-radio-group>
            </el-form-item>

        </el-form>

        <fileSelector v-if="showFileSelector" @finish="onAddFile" fileType="video" />
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onFinish()">确定</el-button>
        </span>
    </el-dialog>


</template>

<script>
import { mapState, mapGetters } from 'vuex'
import fileSelector from "@client/components/file-selector";

export default {
    name: "attr-qk-video",
    props: {
        videoSrcList: {
            type: String | Array,
            default: []
        },
        playTimes: {
            type: Number | String,
            default: 1
        },
        muted: {
            type: Boolean,
            default: true
        }
    },
    components: {
        fileSelector
    },
    data() {
        return {
            tempVideoSrc: [],
            tempPlayTimes: 1,
            tempMuted: true,
            showFileSelector: false,
        }
    },
    mounted() {
        this.init();
        if (typeof(this.videoSrcList) === 'string') {
            this.tempVideoSrc = [this.videoSrcList];
        } else {
            let list = [];
            this.videoSrcList.forEach(item => {
                list.push(item)
            })

            this.tempVideoSrc = list;
        }
        
        this.tempPlayTimes = this.playTimes;
        this.tempMuted = this.muted;
    },
    watch: {},
    computed: {
        ...mapState({
            editActiveElement: state => state.editor.editActiveElement,
            projectData: state => state.editor.projectData
        }),
        ...mapGetters([
            'activePage'
        ]),
    },
    methods: {
        itemOpr(opr, index) {

            if (opr === 'up') {
                if (index > 0) {
                    const deleteArr = this.tempVideoSrc.splice(index, 1);
                    this.tempVideoSrc.splice(index - 1, 0, ...deleteArr)
                }
            } else if (opr === 'down'){
                if (index < this.tempVideoSrc.length - 1) {
                    const deleteArr = this.tempVideoSrc.splice(index + 1, 1);
                    this.tempVideoSrc.splice(index, 0, ...deleteArr)
                }

            } else if (opr === 'delete'){
                this.tempVideoSrc.splice(index, 1);
            }
        },
        init() {
            const _this = this

            let findResult = _this.activePage.elements.some(element => {
                if (element.uuid === _this.editActiveElement.uuid) {
                    return true;
                }

                return false;
            });

            //新增视频
            if (!findResult) {
                const index = _this.activePage.elements.findIndex(element => {
                    return element.elName === 'qk-video'
                });

                if (index >= 0) {
                    _this.$message.error('每个场景下只能添加一个视频');
                    this.handleCloseDialog();
                    return;
                }
            }
        },
        // selectFile(fileInfo) {
        //     this.showFileSelector = false
        //     if (fileInfo === null) {

        //         return;
        //     }

        //     this.tempVideoSrc = fileInfo.file_url;

        // },
        onAddFile(file) {
            this.showFileSelector = false;
            if (file) {
                this.tempVideoSrc.push(file.file_url);
            }
        },
        onFinish() {
            const _this = this

            let findResult = this.activePage.elements.some(element => {
                if (element.uuid === this.editActiveElement.uuid) {
                    element.propsValue.videoSrcList = _this.tempVideoSrc;
                    element.propsValue.playTimes = _this.tempPlayTimes;
                    element.propsValue.muted = _this.tempMuted
                    return true;
                }

                return false;
            });

            if (!findResult) {
                const index = this.activePage.elements.findIndex(element => {
                    return element.elName === 'qk-video'
                });

                if (index >= 0) {
                    this.$message.error('每个场景下只能添加一个视频');
                    return;
                }

                let newEle = _.cloneDeep(this.editActiveElement);
                newEle.propsValue.videoSrcList = _this.tempVideoSrc;
                newEle.propsValue.playTimes = _this.tempPlayTimes;
                newEle.propsValue.muted = _this.tempMuted

                newEle.commonStyle.width = this.projectData.width;
                newEle.commonStyle.height = this.projectData.height;

                this.activePage.elements.push(newEle);
            }

            this.$store.commit('addHistoryCache')

            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$store.dispatch('editActiveElement', null);
        }
    }
}
</script>

<style scoped>
</style>
